import { render, staticRenderFns } from "./HVideo.vue?vue&type=template&id=dafba2de&scoped=true&"
import script from "./HVideo.vue?vue&type=script&lang=js&"
export * from "./HVideo.vue?vue&type=script&lang=js&"
import style0 from "./HVideo.vue?vue&type=style&index=0&id=dafba2de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafba2de",
  null
  
)

export default component.exports